import "./index.css";
import { Experience } from "@/experience";
import { Ui } from "@/ui";
import { usePreview } from "@/hooks/usePreview";
import Preview from "@/utils/components/Preview";

export function App() {
  const isPreview = usePreview();
  
  if (isPreview) return <Preview />;

  return (
    <>
      <Ui />
      <Experience />
    </>
  );
}
